import {HeaderHeightCalculator} from "./headerHeightCalculator";

export class AnchorScrollHandler {
    private readonly headerHeightCalculator: HeaderHeightCalculator;

    constructor() {
        this.headerHeightCalculator = new HeaderHeightCalculator();

        this.initEventListener();
    }

    private initEventListener() {
        document.addEventListener('click', event => {
            const linkElement = event.target as HTMLElement;
            let href = linkElement.getAttribute('href');
            if (!href){
                // wenn man auf ein Bild in einem link klickt z.b dann muss man hoeher gehen
                const closest = linkElement.closest('a, button');
                if(closest) {
                    href = closest.getAttribute('href');
                }
            }

            if (!href || href === '#') {
                return;
            }

            if (href.indexOf('#') !== 0 || linkElement.classList.contains('nav-link')) {
                return;
            }


            const layer = linkElement.closest('.dialog-content') as HTMLElement|null;
            const element = layer ? layer.querySelector(href) : document.querySelector(href);
            if (! element) {
                return;
            }


            event.preventDefault();
            event.stopImmediatePropagation();

            element.scrollIntoView();
            window.scroll(0, window.scrollY - this.headerHeightCalculator.getHeaderHeight());
        });
    }
}
